import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'
import { useId } from 'react'

import { FieldSection } from '../formSection/fieldSection/FieldSection'
import { FormSection } from '../formSection/FormSection'
import { AddNewProgramFormModel } from '../AddNewProgram.types'

import { RichTextEditor } from '@percent/admin-dashboard/common/components/RichTextEditor/RichTextEditor'
import { Checkbox, Feedback } from '@percent/lemonade'

export function AcceptanceEmailCopy() {
  const { t } = useTranslation()

  const {
    setValue,
    control,
    formState: { errors, dirtyFields }
  } = useFormContext<AddNewProgramFormModel>()

  const [acceptanceEmailCopy, rejectionEmailCopy] = useWatch({
    control,
    name: ['acceptanceEmailCopy', 'rejectionEmailCopy']
  })

  const [shouldSendOutcomeEmails] = useWatch({ control, name: ['shouldSendOutcomeEmails'] })

  const acceptanceEmailHintId = useId()
  const rejectionEmailHintId = useId()

  const hasAcceptanceEmailError = !!errors.acceptanceEmailCopy?.message && !!dirtyFields.acceptanceEmailCopy
  const hasRejectionEmailError = !!errors.rejectionEmailCopy?.message && !!dirtyFields.rejectionEmailCopy

  return (
    <FormSection title={t('form.outcomeEmails')}>
      <FieldSection>
        <Checkbox
          variant="default"
          active={shouldSendOutcomeEmails}
          name="shouldSendOutcomeEmails"
          label={t('form.shouldSendOutcomeEmails')}
          onChange={event => {
            const isChecked = (event as React.ChangeEvent<HTMLInputElement>).target.checked
            setValue('shouldSendOutcomeEmails', isChecked)
          }}
        />
      </FieldSection>
      <FieldSection title={t('form.acceptanceEmailCopy')}>
        <RichTextEditor
          fieldName="acceptanceEmailCopy"
          content={acceptanceEmailCopy}
          error={hasAcceptanceEmailError}
          placeholder={t('form.acceptanceEmailPlaceholder')}
          handleBlur={() => {}}
          handleUpdate={(newValue: string) =>
            setValue('acceptanceEmailCopy', newValue, { shouldValidate: true, shouldDirty: true })
          }
        />
        {hasAcceptanceEmailError && (
          <div>
            <Feedback id={acceptanceEmailHintId} variant="critical">
              {errors.acceptanceEmailCopy?.message}
            </Feedback>
          </div>
        )}
      </FieldSection>
      <FieldSection title={t('form.rejectionEmailCopy')}>
        <RichTextEditor
          fieldName="rejectionEmailCopy"
          content={rejectionEmailCopy}
          error={hasRejectionEmailError}
          placeholder={t('form.rejectionEmailPlaceholder')}
          handleBlur={() => {}}
          handleUpdate={(newValue: string) =>
            setValue('rejectionEmailCopy', newValue, { shouldValidate: true, shouldDirty: true })
          }
        />
        {hasRejectionEmailError && (
          <div>
            <Feedback id={rejectionEmailHintId} variant="critical">
              {errors.rejectionEmailCopy?.message}
            </Feedback>
          </div>
        )}
      </FieldSection>
    </FormSection>
  )
}
